import React, { useRef } from 'react';
import { Modal } from '@insurancemenu/imenu-components-lib';
import FormsSpinner from 'components/common/general/FormSpinner';
import { createStyles } from './styles';

export interface FilterModal {
  show: boolean;
  loading: boolean;
  onClose: () => void;
  proposalContent: JSX.Element;
}

const ProposalInfoModal = ({ show, proposalContent, onClose, loading }: FilterModal): JSX.Element => {
  const classes = createStyles();
  const scrollRef = useRef<HTMLDivElement>(null);

  const onModalClose = (): void => {
    scrollRef.current?.scrollTo(0, 0);
    onClose();
  };
  return (
    <Modal show={show} onClose={onModalClose} closable className={classes.modal} modalContainerRef={scrollRef}>
      {loading && <FormsSpinner display={loading} />}
      <div className={classes.proposalContent}>{proposalContent}</div>
    </Modal>
  );
};

export default ProposalInfoModal;
